export class ArchiveMissingDescriptionLevelCreateError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "ArchiveMissingDescriptionLevelCreateError"
    }
}